import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import useFormContext from '../context/useFormContext';
import { FormActionsContext } from '../context/FormContext';
import FormPages from './FormPages';
import ConnectedFormFields from './ConnectedFormFields';
import ConnectedFormButtons from './ConnectedFormButtons';
import Loader from '../../Run/components/Loader';
import FormStyle from './FormStyle';
import FormScripts from './FormScripts';
import FormWatermark from './FormWatermark';
import './Form.css';
import useFormFieldState from '../logic/useFormFieldState';
import useFormDataLayer from '../logic/useFormDataLayer';

var FormContainer = function FormContainer(props) {
  var renderOptions = props.renderOptions;
  var onSubmit = props.onSubmit,
      onLoaded = props.onLoaded,
      onUploadFile = props.onUploadFile;
  var onChanged = props.onChanged,
      onDirtyChanged = props.onDirtyChanged;
  var onFieldFocused = props.onFieldFocused,
      onPageChanged = props.onPageChanged;

  var _useFormContext = useFormContext(),
      state = _useFormContext.state;

  var _React$useContext = React.useContext(FormActionsContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 2),
      actionsState = _React$useContext2[0],
      dispatch = _React$useContext2[1];

  var focusedField = useFormFieldState('FOCUSED_FIELD');

  var _useFormDataLayer = useFormDataLayer('FORM_PAGES_FIELD'),
      pageId = _useFormDataLayer.value;

  var hideNavigationButtons = renderOptions.hideNavigationButtons,
      hideSubmitButton = renderOptions.hideSubmitButton,
      disableSubmitButton = renderOptions.disableSubmitButton;
  var stage = state && state.stage;
  var data = state && state.data;
  var dirty = state.meta && state.meta['FORM'] && state.meta['FORM'].dirty;
  useEffect(function () {
    if (stage === 'loaded') onLoaded && onLoaded();
  }, [stage]);
  useEffect(function () {
    if (stage === 'loaded') onChanged && onChanged();
  }, [data]);
  useEffect(function () {
    var meta = state.meta,
        fields = state.fields;
    var dirty = meta && meta['FORM'] && meta['FORM'].dirty;
    var pageField = fields && fields[pageId];
    if (stage === 'loaded') onPageChanged && onPageChanged(dirty, pageField);
  }, [pageId]);
  useEffect(function () {
    onDirtyChanged && onDirtyChanged(dirty);
  }, [dirty]);
  useEffect(function () {
    if (focusedField.id || focusedField.name) onFieldFocused && onFieldFocused(focusedField);
  }, [focusedField.id, focusedField.index]);
  useEffect(function () {
    dispatch({
      type: 'SET_FORM_UPLOAD_FILE_CALLBACK',
      payload: onUploadFile
    });
  }, [onUploadFile]);
  if (!state || state.stage !== 'loaded') return React.createElement(Loader, null);
  var layout = state.layout;
  var showTabs = layout.paginationType === 'tabs';
  return React.createElement(React.Fragment, null, React.createElement(FormStyle, null), React.createElement(FormWatermark, null), React.createElement(FormScripts, null), React.createElement(Grid, {
    container: true,
    direction: "column",
    className: "ecr-form",
    justify: "flex-start"
  }, showTabs && React.createElement(FormPages, null), React.createElement(Grid, {
    item: true,
    style: {
      width: '100%'
    }
  }, React.createElement(ConnectedFormFields, null)), !hideNavigationButtons && React.createElement(Grid, {
    item: true,
    style: {
      width: '100%'
    }
  }, React.createElement(ConnectedFormButtons, {
    onSubmit: onSubmit,
    submitButtonContent: layout.submitButtonContent,
    backButtonContent: layout.backButtonContent,
    continueButtonContent: layout.continueButtonContent,
    hideSubmitButton: hideSubmitButton,
    disableSubmitButton: disableSubmitButton
  }))));
};

export default FormContainer;